import 'css-chunksrc/client/scenes/secondaryCriteriaTemplate/styles.scss';export default {
  "secondaryCriteriaTemplatePage": "_secondaryCriteriaTemplatePage_3t1t6_1",
  "modal": "_modal_3t1t6_6",
  "toolbar": "_toolbar_3t1t6_10",
  "row": "_row_3t1t6_17",
  "label": "_label_3t1t6_25",
  "button": "_button_3t1t6_31",
  "icon": "_icon_3t1t6_51",
  "iconBox": "_iconBox_3t1t6_59",
  "list": "_list_3t1t6_68",
  "footer": "_footer_3t1t6_75",
  "placeholder": "_placeholder_3t1t6_81"
};